export type EventData = Record<string, any>;

interface GlobalDataLayer {
    push: (data: any) => void;
}

export class DataLayerService {
    public push(data: any) {
        const dataLayer = (window as any).dataLayer as GlobalDataLayer;
        dataLayer.push(data);
    }
}

export const dataLayerService = new DataLayerService();

export function init() {
    (window as any).dataLayer = (window as any).dataLayer || [];
}

export function pushBackendEvents() {
    const element = document.querySelector<HTMLScriptElement>('script[type="application/json"][data-clxgtm-backend-events]');
    if (element === null) {
        return;
    }

    const json = element.textContent;
    if (json === null) {
        return;
    }

    let events;
    try {
        events = JSON.parse(json);
    } catch {
        return;
    }

    if (!Array.isArray(events)) {
        return;
    }

    for (const event of events) {
        dataLayerService.push(event);
    }
}
